// src/components/Privacy.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
//import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import '../App.css';

import Terms from './Terms';
import Error from './Error';


function Privacy() {
  return (
    <div className="App">
      <header className="App-header-page">
        <h1>Privacy Policy</h1>
      </header>
	  <main className="App-main-page">
	  <section style={{ margin: '3%' }}>
	 <div className="content-section terms-container" style={{ padding: '3%' }}>
         
   
    <p>World Radio (“we,” “our,” or “us”) values your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our mobile application. By using the App, you consent to the practices described in this Policy.</p>

    <h2>1. Information We Collect</h2>
    <h3>Automatically Collected Information</h3>
    <p>We collect certain non-personal information automatically when you use the App, including:</p>
    <ul>
        <li>Device details (e.g., manufacturer, model, operating system, and version).</li>
        <li>Usage data (e.g., app interactions and crash reports).</li>
    </ul>
    <h3>Push Notifications</h3>
    <p>We may collect anonymized data to send personalized push notifications about updates, features, or relevant promotions.</p>
    <p><strong>Note:</strong> We do not collect personally identifiable information (PII) or sensitive personal data as defined under applicable laws.</p>

    <h2>2. How We Use Your Information</h2>
    <p>We use the collected information to:</p>
    <ul>
        <li>Improve the App’s functionality and performance.</li>
        <li>Personalize your experience, including delivering relevant push notifications.</li>
        <li>Notify you about updates, features, or services in the App.</li>
    </ul>
    <p>All data is processed in compliance with applicable laws, including GDPR (Europe), COPPA (Americas), and Indian IT laws.</p>

    <h2>3. Sharing Your Information</h2>
    <p>We do not share, sell, or rent your information to any third parties. The data is used solely for internal purposes to enhance your experience.</p>

    <h2>4. Data Retention</h2>
    <p>We retain the data only for as long as necessary to fulfill the purposes outlined in this Policy or as required by law. Once no longer needed, the data is securely deleted or anonymized.</p>

    <h2>5. Security Measures</h2>
    <p>We use industry-standard security measures, including encryption and regular audits, to safeguard your data. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.</p>

    <h2>6. Your Rights and Choices</h2>
    <p>You have the following rights regarding your data:</p>
    <ul>
        <li><strong>Push Notifications:</strong> You can opt out of receiving push notifications at any time through your device settings.</li>
        <li><strong>Location Services:</strong> You can disable location services through your device settings.</li>
    </ul>

    <h2>7. Third-Party Links</h2>
    <p>The App may contain links to third-party websites or services. We are not responsible for the privacy practices or content of these external sites. We recommend reviewing their privacy policies before interacting with them.</p>

    <h2>8. Children’s Privacy</h2>
    <p>World Radio is committed to protecting the privacy of children:</p>
    <ul>
        <li><strong>Age Requirements:</strong>
            <ul>
                <li><strong>Globally:</strong> No personal information is knowingly collected from children under 12.</li>
                <li><strong>EEA:</strong> Users must be 16 or older.</li>
                <li><strong>Mexico:</strong> Users must be 18 or older.</li>
                <li><strong>South Korea:</strong> Users under 14 cannot use the App.</li>
                <li><strong>India:</strong> Users must be 18 or older to access the App, as per local laws.</li>
            </ul>
        </li>
        <li><strong>Parental Responsibility:</strong> Parents and guardians are encouraged to monitor their children’s use of the App and ensure compliance with local age laws.</li>
        <li><strong>Reporting and Removal:</strong> If you believe your child has provided personal information, contact us at  
		<a href="mailto:[Insert Support Email Address]"> curiousitinfo+support@gmail.com</a>. We will promptly delete the information and, if applicable, terminate the child’s access.</li>
        <li><strong>Global Compliance:</strong> The App follows IARC guidelines, recommending a minimum age of 12. Users are responsible for adhering to age requirements in their jurisdiction.</li>
    </ul>

    <h2>9. Global Use and Regional Compliance</h2>
    <p>The App is available worldwide, including the Americas, UK, Europe, Asia, and other regions. We comply with applicable data protection laws, including:</p>
    <ul>
        <li><strong>GDPR:</strong> For European Economic Area users.</li>
        <li><strong>COPPA:</strong> For children’s privacy in the Americas.</li>
        <li><strong>Indian IT laws:</strong> For users in India.</li>
    </ul>
    <p>By using the App, you consent to data processing as described in this Policy, irrespective of your region.</p>

    <h2>10. Policy Updates</h2>
    <p>We may update this Privacy Policy. Any changes will be reflected in the App with an updated “Effective Date.” Continued use of the App after updates constitutes your acceptance of the revised policy.</p>
    <p><strong>Effective Date:</strong> 25th January 2025</p>

    <h2>11. Contact Us</h2>
    <p>For questions, concerns, or requests about this Privacy Policy, please contact:</p>
    <p><strong>World Radio Support Team</strong></p>
    <p><strong>Email:</strong> <a href="mailto:[Insert Support Email Address]">curiousitinfo+support@gmail.com</a>
	</p></div>
        </section>
	  </main>
     <footer className="App-footer-page">
		<Link to="/">Home</Link>   | 
        <Link to="/terms">Terms and Conditions</Link> | 
        <Link to="/privacy">Privacy Policy</Link>
      </footer>
    </div>
  );
}
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/terms" element={<Terms/>} />
        <Route path="/privacy" element={<Privacy/>} />
        <Route path="*" element={<Error/>} />
      </Routes>
    </Router>
  );
}
export default Privacy;
